import axios from "axios";
import React, { createContext, useEffect, useState } from "react";

const AuthContext = createContext();

function AuthContextProvider(props) {
  const [loggedIn, setLoggedIn] = useState(undefined);

  async function getLoggedIn() {
    const token = localStorage.getItem("token");

    try {
      const loggedInRes = await axios.post(
        `${process.env.REACT_APP_BACKEND}/auth/loggedIn`,
        { jwtToken: token }
      );
      setLoggedIn(loggedInRes.data);
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    getLoggedIn();
  }, []);

  return (
    <AuthContext.Provider value={{ loggedIn, getLoggedIn }}>
      {props.children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
export { AuthContextProvider };
